import { Filtro } from './../model/Filtro';
import GenericService from './GenericService';
import { httpService } from './HttpService';


export class FiltroService extends GenericService<Filtro>{
    constructor(){
        super("Filtro")
    }

    getBySorteo(idSorteo: number): Promise<Array<Filtro>> {
        return httpService.get(this.entity+"/sorteo/"+idSorteo);
    }
}